// 全局应用上下文：账号、档案、批注、主题
import { createContext, useContext } from 'react'
import type { BirthProfile } from './lib/bazi'
import type { BaziReading } from './lib/baziReading'
import type { AuthUser } from './lib/api'

export type ThemeMode = 'light' | 'dark' | 'system'

export interface AppContextValue {
  user: AuthUser | null
  authReady: boolean
  login: (email: string, password: string) => Promise<void>
  register: (email: string, password: string, nickname: string) => Promise<void>
  logout: () => Promise<void>
  profiles: BirthProfile[]
  activeProfile: BirthProfile | null
  setActiveProfile: (id: string) => void
  saveProfile: (p: BirthProfile) => void
  deleteProfile: (id: string) => void
  readings: Record<string, BaziReading>
  saveReading: (r: BaziReading) => void
  deleteReading: (profileId: string) => void
  /** 本机旧数据（未同步到账号）的档案数量；0 = 无 */
  localCount: number
  importLocalData: () => Promise<void>
  theme: ThemeMode
  setTheme: (t: ThemeMode) => void
}

export const AppCtx = createContext<AppContextValue>({
  user: null,
  authReady: false,
  login: async () => {},
  register: async () => {},
  logout: async () => {},
  profiles: [],
  activeProfile: null,
  setActiveProfile: () => {},
  saveProfile: () => {},
  deleteProfile: () => {},
  readings: {},
  saveReading: () => {},
  deleteReading: () => {},
  localCount: 0,
  importLocalData: async () => {},
  theme: 'system',
  setTheme: () => {},
})

export function useApp() {
  return useContext(AppCtx)
}
